
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiContentExpandGoogle as ObiContentExpandGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-content-expand-google.js';
 
 
 

 
 export const ObiContentExpandGoogle = createComponent({
   react: React,
   tagName: 'obi-content-expand-google',
   elementClass: ObiContentExpandGoogleElement,
   events: {
     
   }
  });
 
 